import ModalAsignarDenuncia from './ModalAsignarDenuncia';

export default ModalAsignarDenuncia;
